import * as React from "react";
import {Box, Typography} from "@mui/material";
import AgingBadge from "./AgingBadge";

function amountPill(label, paletteSlot, width) {
    return (
        <Box component="span" sx={{
            display: 'inline-block', padding: '4px 11px', borderRadius: '100px',
            fontSize: '12px', fontWeight: 700, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums',
            width, textAlign: 'center',
            backgroundColor: `${paletteSlot}.main`, color: `${paletteSlot}.contrastText`,
        }}>{label}</Box>
    );
}

export function documentNumberChip(numberWithPointOfSale) {
    return (
        <Box component="span" sx={{
            display: 'inline-block', padding: '3px 10px', borderRadius: '6px',
            fontSize: '13px', fontWeight: 700, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums',
            border: '1px solid', borderColor: 'primary.light', backgroundColor: 'background.paper', color: 'primary.dark',
        }}>{numberWithPointOfSale}</Box>
    );
}

export function documentNumberCellRenderer(row) {
    return documentNumberChip(row.numberWithPointOfSale);
}

export function statusCellRendererFor(theme) {
    return (row) => <AgingBadge tierCode={row.statusCode} label={row.statusLabel} theme={theme}/>;
}

export function daysCellRenderer(row) {
    const isCancelled = row.statusCode === 'cancelled';
    if (isCancelled) {
        return <Typography variant="body2" color="text.disabled">{row.daysLabel}</Typography>;
    }
    if (row.overdueDays > 0) {
        return <Typography variant="body2" color="error.main" fontWeight={700}>{row.daysLabel}</Typography>;
    }
    if (row.overdueDays === 0) {
        return <Typography variant="body2" color="warning.main" fontWeight={700}>{row.daysLabel}</Typography>;
    }
    return <Typography variant="body2" color="text.secondary">{row.daysLabel}</Typography>;
}

export function unappliedAmountPill(amount) {
    return amountPill(`Sin aplicar ${amount}`, 'warning', '210px');
}

export function totalPill(amount) {
    return amountPill(amount, 'info', '150px');
}
